class FirebaseSM {
  constructor(config) {
    const defaultConfig = {
      apiKey: "AIzaSyAnCVCQ8WRkdQjwMMV-jGvliCiKq29EbiE",
      authDomain: "remomov2.firebaseapp.com",
      projectId: "remomov2",
      databaseURL: "https://remomov2.firebaseio.com",
      storageBucket: "remomov2.appspot.com",
      messagingSenderId: "421814643462",
    };
    const { initializeApp } = require("firebase/app");
    const { getAuth } = require("firebase/auth");
    const { getFirestore } = require("firebase/firestore");
    const { getDatabase } = require("firebase/database");
    const { getStorage } = require("firebase/storage");

    const firebaseApp = initializeApp(config || defaultConfig);
    this.auth = getAuth(firebaseApp);
    this.fsdb = getFirestore(firebaseApp);
    this.rtdb = getDatabase(firebaseApp);
    this.storage = getStorage(firebaseApp);
  }

  //////////////////Storage ///////////////////////////////////////

  async uploadImage(storagePath, file, metadata, onUploaded, onUploading) {
    const {
      ref,
      uploadBytesResumable,
      getDownloadURL,
    } = require("firebase/storage");
    const storageRef = ref(this.storage, storagePath);
    const uploadTask = uploadBytesResumable(storageRef, file, metadata);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
        }
        if (onUploading) onUploading(progress);
      },
      (error) => {
        console.log("upload error");
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          console.log("File available at", downloadURL);
          onUploaded(downloadURL);
        });
      }
    );
  }
  async deleteImage(storagePath, onDelete) {
    const { ref, deleteObject } = require("firebase/storage");
    const delRef = ref(this.storage, storagePath);
    deleteObject(delRef)
      .then(() => {
        if (onDelete) onDelete();
      })
      .catch((err) => {
        console.log(err);
      });
  }
  ///////// general check //////////////////////
  async checkFB() {
    const result = await this.getDb("admin/check");
    return result;
  }
  /**
   * check connection to firestore
   * need login before check
   * @example
   * const user = await fb.signInFB("xxx@gmail.com", "pwpw");
   * await fb.checkFS();
   */
  async checkFS() {
    const { getFirestore, doc, getDoc } = require("firebase/firestore");
    const testRef = doc(getFirestore(), "admin", "test");
    const docSnap = await getDoc(testRef);
    if (docSnap.exists()) {
      console.log("Firestore Document test:", docSnap.data());
    } else {
      console.log("No such firestore document!");
    }
  }
  ///////// Auth //////////////////////
  /**
   *
   * @param {string} email
   * @param {string} password
   * @returns {object} fb auth user object
   * @example
   * const user =
   * await fb.signInFB("xxx@gmail.com", "pwpwpw");
   * console.log("Logged in, ", user.uid);
   */
  async signInFB(email, password) {
    const { signInWithEmailAndPassword } = require("firebase/auth");
    try {
      const userCredential = await signInWithEmailAndPassword(
        this.auth,
        email,
        password
      );
      const user = userCredential.user;
      console.log("logged in FB user:", user.uid);
      return user;
    } catch (err) {
      console.log("log in error", err.code);
      return err.code;
    }
  }
  signOutFB() {
    const { signOut } = require("firebase/auth");
    signOut(this.auth)
      .then(() => {
        console.log("signed out FB");
        return "success";
      })
      .catch((err) => {
        return err;
      });
  }
  /**
   * original firebase auth function
   */
  get onAuthStateChanged() {
    const { onAuthStateChanged } = require("firebase/auth");
    return onAuthStateChanged;
  }
  /**
   *
   * @param {function(object)} login function on log in
   * @param {function} logout functon on log out
   * @example
   * fb.authChange(
   *   ()=>console.log("Logged in"),
   *   () =>console.log("Logged out")
   * );
   */
  authChange(login, logout) {
    const { onAuthStateChanged } = require("firebase/auth");
    onAuthStateChanged(this.auth, (user) => {
      if (user) {
        login(user);
      } else {
        logout();
      }
    });
  }
  /**
   *
   * @param {string} newPassword
   * @returns {"success"|"fail"}
   */
  async updateAuthPassword(newPassword) {
    const { updatePassword } = require("firebase/auth");
    const user = this.auth.currentUser;
    try {
      await updatePassword(user, newPassword);
      return "success";
    } catch (e) {
      console.log(e);
      return "fail";
    }
  }
  /**
   *
   * @param {string} email
   * @returns {"success"|"fail"}
   */
  async emailResetPassword(email) {
    const { sendPasswordResetEmail } = require("firebase/auth");
    try {
      await sendPasswordResetEmail(this.auth, email);
      return "success";
    } catch (e) {
      console.log("sendPasswordResetEmail fail", e);
      const errorMessage = e.message;
      return errorMessage;

    }
  }
  async createUser(email, password) {
    const { createUserWithEmailAndPassword } = require("firebase/auth");
    try {
      const result = await createUserWithEmailAndPassword(
        this.auth,
        email,
        password
      );
      const user = result.user;
      return { result: "success", uid: user.uid };
    } catch (e) {
      return { result: "fail", message: e.message };
    }
  }

  ///////// original database finctions //////////////////////
  get onValue() {
    const { onValue } = require("firebase/database");
    return onValue;
  }
  get ref() {
    const { ref } = require("firebase/database");
    return ref;
  }

  ///////// database ////////////////////////
  /**
   * Firebase realtime database
   * GET child object
   * @param {string} childPath
   * @returns {object}
   */
  async getDb(childPath) {
    const { ref, child, get } = require("firebase/database");
    const dbRef = ref(this.rtdb);
    try {
      const snapshot = await get(child(dbRef, childPath));
      if (snapshot.exists()) {
        // console.log("key", snapshot.key);
        return snapshot.val();
      } else {
        return { result: "fail" };
      }
    } catch (e) {
      return { result: "fail" };
    }
  }
  /**
   * Firebase realtime database
   * SET child object
   * @param {string} childPath
   * @param {object} setObj
   * @returns {"success"|"fail"}
   */
  async setDb(childPath, setObj) {
    if (childPath === "/" || !childPath) {
      return "fail";
    } else {
      const { ref, set } = require("firebase/database");
      const dbRef = ref(this.rtdb, childPath);
      await set(dbRef, setObj);
      return "success";
    }
  }
  /**
   * Firebase realtime database
   * UPDATE child object
   * @param {string} childPath
   * @param {object} updateObj
   * @returns {"success"|"fail"}
   */
  async updateDb(childPath, updateObj) {
    if (childPath === "/" || !childPath) {
      return "fail";
    } else {
      const { ref, update } = require("firebase/database");
      const dbRef = ref(this.rtdb, childPath);
      await update(dbRef, updateObj);
      return "success";
    }
  }

  /**
   *Firebase realtime database
   * GET child object by start and end key
   * @param {string} childPath
   * @param {string|number} startKey
   * @param {string|number} endKey
   * @param {number} [qty]
   * @param {"desc"|"asc"} [orderBy]
   * @returns {object}
   */
  async getDbByKey(childPath, startKey, endKey, qty, orderBy) {
    const {
      ref,
      query,
      orderByKey,
      get,
      startAt,
      endAt,
      limitToLast,
      limitToFirst,
    } = require("firebase/database");
    let q = query(ref(this.rtdb, childPath), orderByKey());
    if (startKey) {
      q = query(q, startAt(startKey));
    }
    if (endKey) {
      q = query(q, endAt(endKey));
    }
    if (qty) {
      if (orderBy === "desc") {
        q = query(q, limitToLast(qty));
      } else if (orderBy === "asc") {
        q = query(q, limitToFirst(qty));
      }
    }
    try {
      const snapshot = await get(q);
      if (snapshot.exists()) {
        return snapshot.val();
      } else {
        return { result: "fail" };
      }
    } catch (e) {
      return { result: "fail" };
    }
  }

  /**
   * get children where key [childKey] start/equal with [childVal]
   * @param {string} childPath
   * @param {string|number} childVal
   * @param {number} qty
   * @param {"decs"|"asc"} orderBy
   */
  async getDbByChild(childPath, childKey, childVal, qty, orderBy) {
    const {
      ref,
      query,
      orderByChild,
      get,
      startAt,
      endAt,
      limitToLast,
      limitToFirst,
    } = require("firebase/database");
    let q = query(ref(this.rtdb, childPath), orderByChild(childKey));
    q = query(q, startAt(childVal));
    q = query(q, endAt(childVal + "\uf8ff"));
    if (qty) {
      if (orderBy === "desc") {
        q = query(q, limitToLast(qty));
      } else if (orderBy === "asc") {
        q = query(q, limitToFirst(qty));
      }
    }
    try {
      const snapshot = await get(q);
      if (snapshot.exists()) {
        return snapshot.val();
      } else {
        return { result: "no exist" };
      }
    } catch (e) {
      console.log(e);
      return { result: "fail" };
    }
  }

  ///////// original firestore finctions //////////////////////
  /**
   * Firestore original function
   */
  get doc() {
    const { doc } = require("firebase/firestore");
    return doc;
  }
  /**
   * Firestore original function
   */
  get getDoc() {
    const { getDoc } = require("firebase/firestore");
    return getDoc;
  }
  /**
   * Firestore original function
   */
  get collection() {
    const { collection } = require("firebase/firestore");
    return collection;
  }
  /**
   * Firestore original function
   */
  get query() {
    const { query } = require("firebase/firestore");
    return query;
  }
  /**
   * Firestore original function
   */
  get where() {
    const { where } = require("firebase/firestore");
    return where;
  }
  /**
   * Firestore original function
   */
  get orderBy() {
    const { orderBy } = require("firebase/firestore");
    return orderBy;
  }
  /**
   * Firestore original function
   */
  get limit() {
    const { limit } = require("firebase/firestore");
    return limit;
  }
  /**
   * Firestore original function
   */
  get onSnapshot() {
    const { onSnapshot } = require("firebase/firestore");
    return onSnapshot;
  }
  /**
   * Firestore original function
   */
  get writeBatch() {
    const { writeBatch } = require("firebase/firestore");
    return writeBatch;
  }
  /**
   * Firestore original function
   */
  get arrayUnion() {
    const { arrayUnion } = require("firebase/firestore");
    return arrayUnion;
  }
  /**
   * Firestore original function
   */
  get arrayRemove() {
    const { arrayRemove } = require("firebase/firestore");
    return arrayRemove;
  }
  /**
   * Firestore original function
   */
  get deleteField() {
    const { deleteField } = require("firebase/firestore");
    return deleteField;
  }
  ////////////firestore read///////////////////////////////
  /**
   * Firestore get one document
   * @param {string} pathWithDocName
   * @returns {object}
   */
  async getDocFS(pathWithDocName) {
    const { doc, getDoc } = require("firebase/firestore");
    const obj = this.splitPath(pathWithDocName);
    if (!obj) {
      return { result: "fail" };
    } else {
      try {
        const getRef = doc(this.fsdb, obj.collectionPath, obj.docID);
        const docSnap = await getDoc(getRef);
        if (docSnap.exists()) {
          return docSnap.data();
        } else {
          return { result: "doc_not_exist" };
        }
      } catch (e) {
        console.log(e);
        return { result: "fail" };
      }
    }
  }
  /**
   *
   * @param {string} pathEndWithCollection
   * @param {"array"|"object"} resultType
   * @param {string} [whereField]
   * @param {"=="|">"|"<"|"array-contains"|"in"} [compareOperator]
   * @param {string} [compareVal]
   * @param {string} [orderByField]
   * @param {"desc"|"asc"} [order]
   * @param {number} [qty]
   * @param {string} [rangeField]
   * @param {string|number} [upperRange]
   * @param {string|number} [lowerRange]
   * @param {boolean} [returnError]
   * @returns {Array<*>|object}
   * @example
   * const list = await fb.getDocsWhereFS(
      "/invContent","array",
      "clientName", "==","abc",
      "invoiceTsp","desc",30,
      "invoiceTsp",upperTsp,lowerTsp
    );
   */
  async getDocsWhereFS(
    pathEndWithCollection,
    resultType,
    whereField,
    compareOperator,
    compareVal,
    orderByField,
    order,
    qty,
    rangeField,
    upperRange,
    lowerRange,
    returnError
  ) {
    const {
      collection,
      query,
      where,
      getDocs,
      orderBy,
      limit,
    } = require("firebase/firestore");
    let q = query(collection(this.fsdb, pathEndWithCollection));
    if (whereField && compareOperator) {
      q = query(q, where(whereField, compareOperator, compareVal));
    }
    if (orderByField && order) {
      q = query(q, orderBy(orderByField, order));
    }
    if (qty) {
      q = query(q, limit(qty));
    }
    if (rangeField) {
      q = query(
        q,
        where(rangeField, "<=", upperRange),
        where(rangeField, ">=", lowerRange)
      );
    }
    try {
      const querySnapshot = await getDocs(q);
      let json = {},
        array = [];
      querySnapshot.forEach((doc) => {
        const docID = doc.id;
        json[docID] = doc.data();
        array = [...array, doc.data()];
      });
      if (resultType === "object") {
        return json;
      } else {
        return array;
      }
    } catch (e) {
      if (returnError) {
        return e;
      } else {
        return { result: "fail" };
      }
    }
  }
  /**
   * Get many docs from Firestore
   * @param {string} collectionPath
   * @param {("array"|"json"|"object")} dataType
   * @param {string} compareField
   * @param {"=="|">"|">="|"<"|"<="|"array-contains"|"in"|"!="} operator
   * @param {string|number|Array<string>} compareVal is array if use "in" operator
   * @param {string} [compareField2]
   * @param {"=="|">"|">="|"<"|"<="|"array-contains"|"in"|"!="} [operator2]
   * @param {string|number|Array<string>} [compareVal2] is array if use "in" operator
   * @param {boolean} [returnError]
   * @returns {Array<*>|object}
   * @example
   * const list = await getManyDocs("/invContent", "array", "invDate","==",dateString);
   * console.log(list);
   */
  async getManyDocs(
    collectionPath,
    dataType,
    compareField,
    operator,
    compareVal,
    compareField2,
    operator2,
    compareVal2,
    returnError
  ) {
    const { collection, query, where, getDocs } = require("firebase/firestore");
    let q = query(collection(this.fsdb, collectionPath));
    q = query(q, where(compareField, operator, compareVal));
    if (compareField2 && operator2) {
      q = query(q, where(compareField2, operator2, compareVal2));
    }
    try {
      const querySnapshot = await getDocs(q);
      let json = {},
        array = [];
      querySnapshot.forEach((doc) => {
        const docID = doc.id;
        json[docID] = doc.data();
        array = [...array, doc.data()];
      });
      if (dataType === "json" || dataType === "object") {
        return json;
      } else {
        return array;
      }
    } catch (e) {
      if (returnError) {
        return e;
      } else {
        return { result: "fail" };
      }
    }
  }
  async getManyDocsWhere(
    collectionPath,
    dataType,
    compareFieldArr,
    operatorArr,
    compareValArr,
    returnError
  ) {
    const { collection, query, where, getDocs } = require("firebase/firestore");
    let q = query(collection(this.fsdb, collectionPath));
    for (let i = 0; i < compareFieldArr.length; i++) {
      q = query(q, where(compareFieldArr[i], operatorArr[i], compareValArr[i]));
    }
    try {
      const querySnapshot = await getDocs(q);
      let json = {},
        array = [];
      querySnapshot.forEach((doc) => {
        const docID = doc.id;
        json[docID] = doc.data();
        array = [...array, doc.data()];
      });
      if (dataType === "json" || dataType === "object") {
        return json;
      } else {
        return array;
      }
    } catch (e) {
      if (returnError) {
        return e;
      } else {
        return { result: "fail" };
      }
    }
  }
  async asyncForEach(array, callback, onCompleteCallback) {
    if (array?.length > 0) {
      for (let index = 0; index < array?.length; index++) {
        await callback(array[index], index, array);
      }
    }
    if (onCompleteCallback) await onCompleteCallback();
  }

  async getDocsByFieldArray(
    pathEndWithCollection,
    fieldName,
    fieldArray,
    compareFieldArr,
    operatorArr,
    compareValArr
  ) {
    const chunk = (arr, n) =>
      arr.length ? [arr.slice(0, n), ...chunk(arr.slice(n), n)] : [];
    const arrInArr = chunk(fieldArray, 10);
    //   console.log("chunk array", arrInArr);
    let resultArray = [];

    await this.asyncForEach(arrInArr, async (arr) => {
      const result = await this.getManyDocsWhere(
        pathEndWithCollection,
        "array",
        [fieldName, ...compareFieldArr],
        ["in", ...operatorArr],
        [arr, ...compareValArr]
      );
      resultArray = [...resultArray, ...result];
    });
    return resultArray;
  }

  /////////////////firestore write//////////////////////////////
  /**
   *
   * @param {string} pathWithDocName
   * @param {object} updateObj
   * @returns {"success"|"fail"}
   */
  async updateDocFS(pathWithDocName, updateObj) {

    const obj = this.splitPath(pathWithDocName);
    if (!obj) {
      return "fail";
    } else {
      const { doc, updateDoc } = require("firebase/firestore");
      try {
        const ref = doc(this.fsdb, obj.collectionPath, obj.docID);
        updateObj = this.jsonCheckNull(updateObj);
        await updateDoc(ref, updateObj);
        return "success";
      } catch (e) {
        return "fail";
      }
    }
  }
  jsonCheckNull(obj, defaultValue = "") {
    for (let key in obj) {
      if (obj[key] === null || obj[key] === undefined) {
        obj[key] = defaultValue;
      }
    }
    return obj;
  }
  /**
   *
   * @param {string} pathWithDocName
   * @param {object} setObj
   * @returns {"success"|"fail"}
   */
  async setDocFS(pathWithDocName, setObj) {
    const obj = this.splitPath(pathWithDocName);
    if (!obj) {
      return "fail";
    } else {
      const { doc, setDoc } = require("firebase/firestore");
      try {
        const ref = doc(this.fsdb, obj.collectionPath, obj.docID);
        setObj = this.jsonCheckNull(setObj);
        await setDoc(ref, setObj);
        return "success";
      } catch (e) {
        return "fail";
      }
    }
  }
  /**
   *
   * @param {string} pathWithDocName
   * @returns {"success"|"fail"}
   */
  async deleteDocFS(pathWithDocName) {
    const obj = this.splitPath(pathWithDocName);
    if (!obj) {
      return "fail";
    } else {
      const { doc, deleteDoc } = require("firebase/firestore");
      try {
        const ref = doc(this.fsdb, obj.collectionPath, obj.docID);
        await deleteDoc(ref);
        return "success";
      } catch (e) {
        return "fail";
      }
    }
  }

  /**
   * multiWrite set/update/delete docs to firestore using 4 arrays.
   * @param {Array<("set"|"update"|"delete")>} typeArr
   * @param {Array<string>} pathArr
   * @param {Array<string>} docIDArr
   * @param {Array<object|"">} objArr
   * @example
   * const typeArr = ["set","update","delete"];
   * const pathArr = ["/invoices","/PV_serial","/SM_serial"];
   * const docIDArr = ["inv145","xt298","d9487"];
   * const objArr = [{invNo:"inv145",amt:56}, {descript:"pv sys",power:67}, ""]
   * await multiWrite(typeArr, pathArr, docIDArr, objArr);
   */
  async multiWrite(typeArr, pathArr, docIDArr, objArr) {
    const { doc, writeBatch } = require("firebase/firestore");
    const batch = writeBatch(this.fsdb);
    typeArr.forEach((type, i) => {
      if (pathArr[i] && docIDArr[i]) {
        const ref = doc(this.fsdb, pathArr[i], docIDArr[i]);
        if (type === "set") {
          batch.set(ref, objArr[i]);
        } else if (type === "update") {
          batch.update(ref, objArr[i]);
        } else if (type === "delete") {
          batch.delete(ref);
        }
      }
    });
    await batch.commit();
  }

  /**
   * multi doc write (set/update/delete/arrayUnion/addField) to firestore using array of object.
   * @param {Array.<{type:("set"|"update"|"delete"|"arrayUnion"|"arrayRemove"|"deleteField"|"addField"),
   * colPath:string, docID:string, obj:JSON,
   * field:string, value:any, fieldKey:string }>} arr - array of {type:set,colPath:xx,...}
   * @returns {"success"|"fail"}
   * @example
   * const arr=[
   *  {type:"set",colPath:"/invoice",docID:"inv123",obj:{no:inv123,amt:98}},
   *  {type:"update",colPath:"/invoice",docID:"inv124",obj:{amt:87}},
   *  {type:"delete",colPath:"/invoice",docID:"inv124"},
   *  {type:"arrayUnion",colPath:"/invoice",docID:"inv125",field:"product",value:"apple"},
   *  {type:"arrayRemove",colPath:"/invoice",docID:"inv125",field:"product",value:"orange"},
   *  {type:"deleteField",colPath:"/PV_serial",docID:"1ab2cd",field:"data",value:"Iac3"},
   *  {type:"addField",colPath:"/PV_serial",docID:"1ab2c",field:"data",fieldKey:"Iac2",value:42},
   *  {type:"deleteBasicField",colPath:"/PV_serial",docID:"1ab2cd",field:"data"}
   * ]
   * await multiDocWriteFS(arr);
   *
   */
  async multiDocWriteFS(arr) {
    const {
      doc,
      writeBatch,
      arrayUnion,
      arrayRemove,
      deleteField,
    } = require("firebase/firestore");
    const batch = writeBatch(this.fsdb);
    for (let tp of arr) {
      const { type, colPath, docID, obj, field, fieldKey, value } = tp;
      const ref = doc(this.fsdb, colPath, docID);
      if (type === "set") {
        const setObj = this.jsonCheckNull(obj);
        batch.set(ref, setObj);
      } else if (type === "update") {
        const updateObj = this.jsonCheckNull(obj);
        batch.update(ref, updateObj);
      } else if (type === "delete") {
        batch.delete(ref);
      } else if (type === "arrayUnion") {
        batch.update(ref, { [field]: arrayUnion(value) });
      } else if (type === "arrayRemove") {
        batch.update(ref, { [field]: arrayRemove(value) });
      } else if (type === "deleteField") {
        batch.update(ref, { [`${field}.${value}`]: deleteField() });
      } else if (type === "addField") {
        batch.update(ref, { [`${field}.${fieldKey}`]: value });
      } else if (type === "deleteBasicField") {
        batch.update(ref, { [field]: deleteField() });
      }
    }
    try {
      await batch.commit();
      return "success";
    } catch (e) {
      return "fail";
    }
  }

  /**
   *
   * @param {string} pathWithDocName
   * @param {string} field
   * @param {string|number} item
   * @returns {"success"|"fail"}
   */
  async unionArrayItemFS(pathWithDocName, field, item) {
    const obj = this.splitPath(pathWithDocName);
    if (!obj) {
      return "fail";
    } else {
      const { doc, updateDoc, arrayUnion } = require("firebase/firestore");
      try {
        const ref = doc(this.fsdb, obj.collectionPath, obj.docID);
        const updateObj = { [field]: arrayUnion(item) };
        await updateDoc(ref, updateObj);
        return "success";
      } catch (e) {
        return "fail";
      }
    }
  }
  /**
   *
   * @param {string} pathWithDocName
   * @param {string} field
   * @param {stirng|number} item
   * @returns {"success"|"fail"}
   */
  async removeArrayItemFS(pathWithDocName, field, item) {
    const obj = this.splitPath(pathWithDocName);
    if (!obj) {
      return "fail";
    } else {
      const { doc, updateDoc, arrayRemove } = require("firebase/firestore");
      try {
        const ref = doc(this.fsdb, obj.collectionPath, obj.docID);
        const updateObj = { [field]: arrayRemove(item) };
        await updateDoc(ref, updateObj);
        return "success";
      } catch (e) {
        return "fail";
      }
    }
  }

  /**
   *
   * @param {string} pathWithDocName
   * @param {string} field
   * @param {string} fieldKey
   * @param {string|number} fieldValue
   * @returns {"success"|"fail"}
   */
  async addFieldValueFS(pathWithDocName, field, fieldKey, fieldValue) {
    const obj = this.splitPath(pathWithDocName);
    if (!obj) {
      return "fail";
    } else {
      const { doc, updateDoc } = require("firebase/firestore");
      try {
        const ref = doc(this.fsdb, obj.collectionPath, obj.docID);
        const updateObj = { [`${field}.${fieldKey}`]: fieldValue };
        await updateDoc(ref, updateObj);
        return "success";
      } catch (e) {
        return "fail";
      }
    }
  }

  /**
   *
   * @param {string} pathWithDocName
   * @param {string} field
   * @param {string|number} fieldValue
   * @returns {"success"|"fail"}
   */
  async removeFieldValueFS(pathWithDocName, field, fieldValue) {
    const obj = this.splitPath(pathWithDocName);
    if (!obj) {
      return "fail";
    } else {
      const { doc, updateDoc, deleteField } = require("firebase/firestore");
      try {
        const ref = doc(this.fsdb, obj.collectionPath, obj.docID);
        const updateObj = { [`${field}.${fieldValue}`]: deleteField() };
        await updateDoc(ref, updateObj);
        return "success";
      } catch (e) {
        return "fail";
      }
    }
  }

  /**
   *
   * @param {string} pathEndWithCollection
   * @param {string} [whereField]
   * @param {"=="|">"|">="|"<"|"<="|"array-contains"|"in"|"!="} [compareOperator]
   * @param {string|number} [compareVal]
   * @param {Array<string>} [docIdArray] optional - will not get docs if docIdArray provided
   * @example
   * deleteMultiDocFS("SM_schedule","serial","==","1aaa2bbb")
   * OR
   * deleteMultiDocFS("SM_zoneControl","","","",["zc_111","zc_222","zc_333"])
   *
   */
  async deleteMultiDocFS(
    pathEndWithCollection,
    whereField,
    compareOperator,
    compareVal,
    docIdArray
  ) {
    let objAll = {};
    if (!docIdArray) {
      objAll = await this.getDocsWhereFS(
        pathEndWithCollection,
        "object",
        whereField,
        compareOperator,
        compareVal
      );
    }

    let arr = [];
    let idArr = docIdArray ? docIdArray : Object.keys(objAll);
    idArr.forEach((docID) => {
      const item = { type: "delete", colPath: pathEndWithCollection, docID };
      arr = [...arr, item];
    });
    await this.multiDocWriteFS(arr);
  }

  //////////////////general ///////////////////////////////////////
  splitPath(pathWithDocName) {
    const i = pathWithDocName.lastIndexOf("/");
    const collectionPath = pathWithDocName.slice(0, i);
    const docID = pathWithDocName.slice(i + 1);
    if (collectionPath && docID) {
      return { collectionPath, docID };
    } else {
      return null;
    }
  }
}

module.exports = FirebaseSM;
